import { Box, Skeleton, Text } from '@mantine/core';
import NoNds from '@/components/common/NoNds';
import { useInView } from '@/hooks/useInView';
import { usePurchasePriceList } from '@/hooks/useBuy';
import { priceRangeOf } from '@/lib/buyTree';
import { formatMoney } from '@/lib/format';
import type { PriceListGroup } from '@/types/buy';

// Диапазон моих цен в строке/ячейке («14 000–14 300 ₽/т»). Запрос ленивый — стартует, когда
// элемент попал во вьюпорт (длинные списки не порождают шквал запросов). Ключ запроса тот же,
// что у детали, поэтому drill-in открывается из кэша мгновенно. Ошибка/пустота — мягкие.
export default function PriceRangeHint({ group }: { readonly group: PriceListGroup }) {
  const { ref, inView } = useInView();
  const { data, isLoading, isError } = usePurchasePriceList(
    inView
      ? {
          address: group.address,
          addressTitle: group.addressTitle,
          goods: group.goods,
          year: group.year,
        }
      : null,
  );

  if (!inView || isLoading) {
    return (
      <Box ref={ref}>
        <Skeleton h={14} w={120} />
      </Box>
    );
  }
  if (isError || !data) {
    return null;
  }
  const range = priceRangeOf(data);
  if (!range) {
    return null;
  }
  const value =
    range.min === range.max
      ? formatMoney(range.min)
      : `${formatMoney(range.min)}–${formatMoney(range.max)}`;
  return (
    <Text size="sm" style={{ whiteSpace: 'nowrap' }}>
      <Text component="span" fw={600} c="brand.9">
        {value}
      </Text>{' '}
      <Text component="span" c="gray.7">
        ₽/т
      </Text>
      <NoNds />
    </Text>
  );
}
